import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const HotelBoxHeader = styled.div(
  ({theme}) => css`
    padding: 8px 16px;
    ${theme.typography.labelMediumBold};
    color: ${theme.colors.contentInversePrimary};
    background: ${theme.colors.backgroundBrand};
    border-radius: 5px 5px 0 0;

    + div {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      background-color: ${theme.colors.backgroundStateSelected};
    }
  `
);
